import React from "react"

import {H4} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import StepIndicator from "@irati/ui/src/StepIndicator"

import {StepNames} from "../../../enums"
import {StepIndicatorHeader} from "../styled"

interface Props {
  currentStep: number
}

const STEPS = [
  {name: StepNames.Recipients, label: <FormattedMessage id="wallet.reward.admin.distribute.recipients" />},
  {name: StepNames.Message, label: <FormattedMessage id="wallet.reward.admin.distribute.message" />},
  {name: StepNames.Confirm, label: <FormattedMessage id="wallet.reward.admin.distribute.confirm" />}
]

const DistributeRewardStepIndicator: React.FC<Props> = ({currentStep}) => {
  return (
    <StepIndicatorHeader direction="column" justifyContent="space-between" marginBottom={2}>
      <H4 paddingBottom paddingTop>
        {STEPS[currentStep - 1].label}
      </H4>
      <StepIndicator currentStep={currentStep} stepsCount={STEPS.length} />
    </StepIndicatorHeader>
  )
}

export default DistributeRewardStepIndicator
